import styled from '@emotion/styled'
import { COLORS } from 'styling/variables'

export const ContentDescription = styled('div')(({ customCss }) => ({
  marginBottom: 20,
  color: COLORS.mainGray,
  ...customCss,
}))
